export default [
  { text: 'Mini', value: 'mini' },
  { text: 'Ürün seçimi', parent: 'mini', disabled: true },
  { text: 'Moodboard (İlham Panosu)', parent: 'mini', disabled: true },
  { text: 'Alışveriş Listesi', parent: 'mini', disabled: true },
  { text: 'Midi', value: 'midi' },
  { text: 'Ürün seçimi', parent: 'midi', disabled: true },
  { text: 'Moodboard (İlham Panosu)', parent: 'midi', disabled: true },
  { text: '2D Ölçülü Plan Yerleşimi', parent: 'midi', disabled: true },
  { text: '1 Revizyon', parent: 'midi', disabled: true },
  { text: 'Full', value: 'full' },
  { text: 'Ürün seçimi', parent: 'full', disabled: true },
  { text: 'Moodboard (İlham Panosu)', parent: 'full', disabled: true },
  { text: '2D Ölçülü Plan Yerleşimi', parent: 'full', disabled: true },
  { text: '3D Görsel Çizim', parent: 'full', disabled: true },
  { text: 'Alışveriş Listesi', parent: 'full', disabled: true },
  { text: '1 Revizyon', parent: 'full', disabled: true },
];
